import React, { useState } from 'react';
import SettingsTab from './SettingsTab';
import ScheduledEmailsTab from './ScheduledEmailsTab';
import PermissionsTab from './PermissionsTab';
import LoginActivityTab from './LoginActivityTab';
import { Tabs, DashboardFrame } from '../ui';

type TabKey = 'scheduled-emails' | 'permissions' | 'login-activity' | 'settings';

const TABS: { value: TabKey; label: string }[] = [
  { value: 'scheduled-emails', label: 'Scheduled Emails' },
  { value: 'permissions',      label: 'Permissions' },
  { value: 'login-activity',   label: 'Login Activity' },
  { value: 'settings',         label: 'Settings' },
];

const AdminDashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabKey>('scheduled-emails');

  const renderTab = () => {
    switch (activeTab) {
      case 'scheduled-emails': return <ScheduledEmailsTab />;
      case 'permissions':      return <PermissionsTab />;
      case 'login-activity':   return <LoginActivityTab />;
      case 'settings':         return <SettingsTab />;
      default:                 return null;
    }
  };

  return (
    <DashboardFrame
      eyebrow="Admin · Pipelines & permissions"
      title="Admin Console"
      tabs={
        <Tabs<TabKey>
          value={activeTab}
          onChange={setActiveTab}
          variant="underlined"
          options={TABS}
        />
      }
    >
      {renderTab()}
    </DashboardFrame>
  );
};

export default AdminDashboard;
